
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/usr/src/app/ui/features/discussion-topic/jst/-reply-form';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"discussion-entry-reply-area reply-box-container hide-if-collapsed hide-if-replying\">\n    <div class=\"notification\" data-bind=\"notification\"></div>\n    <a role=\"button\" class=\"discussion-reply-action discussion-reply-box\" data-event=\"addReply\" href=\"#\">\n      <i class=\"icon-replied\"></i>\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.reply_form")
  },data:data},helper ? helper.call(depth0, "discussions.reply_form.write_a_reply", "Reply", options) : helperMissing.call(depth0, "t", "discussions.reply_form.write_a_reply", "Reply", options)))
    + "</span>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isForMainDiscussion), {hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </a>\n  </div>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.reply_form")
  },data:data},helper ? helper.call(depth0, "reply_to_title_f227303f", "Reply to %{title}", options) : helperMissing.call(depth0, "t", "reply_to_title_f227303f", "Reply to %{title}", options)))
    + "</span>\n      ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("discussions.reply_form")
  },data:data},helper ? helper.call(depth0, "reply_to_comment_72d96728", "Reply to Comment", options) : helperMissing.call(depth0, "t", "reply_to_comment_72d96728", "Reply to Comment", options)))
    + "</span>\n      ";
  return buffer;
  }

function program6(depth0,data) {
  
  
  return "root_";
  }

function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <a href=\"#\" class=\"discussion-reply-add-attachment discussion-reply-action icon-paperclip\"\n             data-event=\"addReplyAttachment\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.reply_form")
  },data:data},helper ? helper.call(depth0, "discussions.reply_form.attach_file", "Attach", options) : helperMissing.call(depth0, "t", "discussions.reply_form.attach_file", "Attach", options)))
    + "</a>\n        ";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showBoxReplyLink), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<div class='discussion-entry-reply-area hide-if-collapsed show-if-replying'>\n  <form class=\"discussion-reply-form\">\n    <div class=\"clearfix\" aria-hidden=\"true\">&nbsp;</div>\n    <textarea class=\"reply-textarea\"\n              id=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.root), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "reply_message_for_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></textarea>\n\n    <div class=\"clearfix\">\n      <div class=\"discussion-reply-attachments-container\">\n        <ul class=\"discussion-reply-attachments\"></ul>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canAttach), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n\n      <div class=\"discussion-reply-buttons\">\n        <a href=\"javascript:\" class=\"cancel_button btn btn-small\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.reply_form")
  },data:data},helper ? helper.call(depth0, "discussions.reply_form.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "discussions.reply_form.cancel", "Cancel", options)))
    + "</a>\n        <button class=\"btn btn-primary btn-small\" type=\"submit\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.reply_form")
  },data:data},helper ? helper.call(depth0, "discussions.reply_form.post_reply", "Post Reply", options) : helperMissing.call(depth0, "t", "discussions.reply_form.post_reply", "Post Reply", options)))
    + "</button>\n      </div>\n    </div>\n  </form>\n</div>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/features/discussion_topic/jst/_reply_form.handlebars', templates['/usr/src/app/ui/features/discussion-topic/jst/-reply-form']);
    ;
    ;
    export default templates[name];
  